<ng-terminal #term></ng-terminal>